import {
    Observable
} from "rxjs/Observable"
import {
    // eslint-disable-next-line no-unused-vars
    ofType
} from "rxjs"
import {
    SCHEDULE_ITEMS_FETCH,
    SCHEDULE_ITEM_CUD_SUCCESS,
    scheduleItemsFetched,
    scheduleItemsFetchError,
    SCHEDULE_ITEM_CUD,
    scheduleItemCudSuccess,
    scheduleItemCudError
} from "../actions/schedule";

const scheduleFetchAllDataEndpoint = `${process.env.REACT_APP_API_HOST}/schedule`
const schedulePostDataEndpoint = (collection) => `${process.env.REACT_APP_API_HOST}/schedule/${collection}`
const schedulePostPatchDeleteEndpoint = (collection, id) => `${process.env.REACT_APP_API_HOST}/schedule/${collection}/${id}`

export const scheduleFetchDataEpic = action$ =>
    action$.ofType(SCHEDULE_ITEMS_FETCH)
    .switchMap(() => {
        return Observable.ajax.getJSON(scheduleFetchAllDataEndpoint, {
                Authorization: `Bearer ${localStorage.getItem("token")}` || ""
            })
            .map(respone => scheduleItemsFetched(respone.data))
            .catch(error => Observable.of(scheduleItemsFetchError(error)))
    })

export const scheduleFetchAfterCUDEpic = action$ =>
    action$.ofType(SCHEDULE_ITEM_CUD_SUCCESS)
    .switchMap(() => {
        return Observable.ajax.getJSON(scheduleFetchAllDataEndpoint, {
                Authorization: `Bearer ${localStorage.getItem("token")}` || ""
            })
            .map(respone => scheduleItemsFetched(respone.data))
            .catch(error => Observable.of(scheduleItemsFetchError(error)))
    })

export const scheduleCUDEpic = action$ =>
    action$.ofType(SCHEDULE_ITEM_CUD)
    .switchMap(({
        payload
    }) => {
        switch (payload.action) {
            case "create": {
                return Observable.ajax.post(schedulePostDataEndpoint(payload.collection), payload.data, {
                        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
                    })
                    .map(response => scheduleItemCudSuccess(response.response))
                    .catch(error => Observable.of(scheduleItemCudError(error)))
            }
            case "update": {
                return Observable.ajax.patch(schedulePostPatchDeleteEndpoint(payload.collection, payload.id), payload.data, {
                        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
                    })
                    .map(response => scheduleItemCudSuccess(response.response))
                    .catch(error => Observable.of(scheduleItemCudError(error)))
            }
            case "delete": {
                return Observable.ajax.delete(schedulePostPatchDeleteEndpoint(payload.collection, payload.id), {
                        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
                    })
                    .map(response => scheduleItemCudSuccess(response.response))
                    .catch(error => Observable.of(scheduleItemCudError(error)))
            }
            default: {
                // console.log("Unknown CUD action: ", payload)
            }
        }
    })
